import React, { useEffect, useState } from "react";
import "./home.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";

import { isloading } from "../redux/reducer/LoadingReducer";
import AxiosInstance from "../Utility/AxiosInstance";
const HqHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [total, setTotal] = useState(0);
  const [pending, setPending] = useState(0);
  const [rejected, setRejected] = useState(0);
  const [approved, setApproved] = useState(0);
  const fetchDashboardData = async () => {
    const token = sessionStorage.getItem("userToken");

    if (!token) return navigate("/login");
    dispatch(isloading());
    try {
      const res = await AxiosInstance.get(`${BaseUrl}/api/dashboard/hq/counts`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (res.data.status === 200) {
        const summary = res.data.data || {};
        const pendingCount = Number(summary.pending) || 0;
        const approvedCount = Number(summary.approved ?? summary.verified) || 0;
        const rejectedCount = Number(summary.rejected) || 0;
        setPending(pendingCount);
        setApproved(approvedCount);
        setRejected(rejectedCount);
        setTotal(Number(summary.total) || pendingCount + approvedCount + rejectedCount);
      } else {
        toast.error("Failed to fetch data.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <div className="home-dashboard">
      <h3>Dashboard</h3>
      <div className="dashboard-stats">
        
          <>
            <div
              className="stat-card"
              onClick={() => navigate("/dashboard/hq/registration-data")}
            >
              <h3>Total Applications</h3>
              <p className="text-center">{total || 0}</p>
            </div>
            <div
              className="stat-card"
              onClick={() =>
                navigate("/dashboard/hq/hq-registration-data", {
                  state: { status: "PENDING"},
                })
              }
            >
              <h3>Pending Applications</h3>
              <p className="text-center">{pending || 0}</p>
            </div>
            <div className="stat-card" onClick={() =>
                navigate("/dashboard/hq/hq-registration-data", {
                  state: { status: "APPROVED"},
                })
              }>
              <h3>Approved Applications</h3>
              <p className="text-center">{approved || 0}</p>
            </div>
            <div className="stat-card" onClick={() =>
                navigate("/dashboard/hq/hq-registration-data", {
                  state: { status: "REJECTED"},
                })
              }>
              <h3>Rejected Applications</h3>
              <p className="text-center">{rejected || 0}</p>
            </div>{" "}
          </>
       
      </div>
    </div>
  );
};

export default HqHome;
